<template>
  <div class="myRegistration">
    <h3 class="containner-title">{{$t("message.training")}}</h3>
    <div class="card-body border" style="background-color: #f1f1f1;">
        <form class="form" v-on:submit.prevent>
          <div class="row mb-2">
            <div class="col">
              <label for="title" class="form-label">{{$t("message.title")}}</label>
              <input type="text" 
                v-model="search.title"
                class="form-control" 
                :placeholder="$t('message.title')" 
                aria-label="title">
            </div>
            <div class="col">
              <label for="first-name" class="form-label">{{$t("message.register_type")}}</label>
              <select
                class="form-select"
                v-model="search.apply_for"
              >
                <option value="" selected>Choose...</option>
                <option value="1">New</option>
                <option value="2">CPE</option>
              </select>
            </div>
            <div class="col">
              <label for="first-name" class="form-label">{{$t("message.business_type")}}</label>
              <select
                class="form-select"
                v-model="search.type"
              >
                <option value="" selected>Choose...</option>
                <option value="1">{{$t("message.stock_business")}}</option>
                <option value="4">{{$t("message.found")}}</option>
                <option value="2">{{$t("message.derivative_business")}}</option>
              </select>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-12" style="text-align: right;margin-top: 5px;">
              <router-link class="btn btn-success m-1" :to="{ name: 'createAdminTrainingGroup' }"><i class="fas fa-plus"></i> {{$t("message.add_new")}}</router-link>
              <button class="btn btn-primary" @click="loadData"><i class="fas fa-search"></i> {{$t("message.search")}}</button>
            </div>
          </div>
        </form>
    </div>
    <div class="row">
        <label class="text-end fs-5 fw-bold p-2">{{$t("message.total")}}: <span class="text-primary">{{total}}</span></label> 
    </div>
    <table class="table table-bordered table-striped">
      <thead class="table-dark">
        <tr>
          <th class="align-middle">#</th>
          <th class="align-middle">{{$t("message.title")}}</th>
          <th class="text-center align-middle">{{$t("message.register_type")}}</th>
          <th class="text-center align-middle" style="width:250px;">{{$t("message.business_type")}}</th>
          <th class="text-center align-middle">{{$t("message.training_date")}}</th>
          <th class="text-center align-middle">{{$t("message.examination_date")}}</th>
          <th class="text-center align-middle">{{$t("message.number_of_participants")}}</th>
          <th class="text-center align-middle" style="vertical-align: middle;width: 150px; text-align:center;">{{$t("message.action")}}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, key) in dataTraining" :key="key">
          <th style="vertical-align: middle;width: 30px;">{{key+1}}</th>
          <td style="vertical-align: middle;">
            {{item.title}}
          </td>
          <td class="text-center" style="vertical-align: middle;">{{item.apply_for==1 ? 'New' : item.apply_for==2 ? 'CPE' : ''}}</td>
          <td style="vertical-align: middle;">{{getBusinessType(item.type)}}</td>
          <td class="text-center" style="vertical-align: middle;">{{item.start_date}} -  {{item.end_date}}</td>
          <td class="text-center" style="vertical-align: middle;">
            {{item.exam_date}}<br>{{item.start_time}} - {{item.end_time}}
          </td>
          <td class="text-center" style="vertical-align: middle;">{{item.total_register}}</td>
          <td style="vertical-align: middle; width:150px;" class="text-end">
            <div class="btn-group">
              <router-link class="btn btn-success" :to="{ name: 'showAdminTrainingGroup' , params:{id:item.id}}">
                <i class="far fa-edit"></i>
              </router-link>
              <router-link class="btn btn-primary" 
                :to="{ name: 'participantAdminTrainingGroup' , params:{id:item.id}}">
                <i class="fas fa-users"></i>
              </router-link>
              <button class="btn btn-danger" @click="deleteData(item)">
                <i class="fas fa-trash-alt"></i>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import axios from "@/axios";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
    };
  },
  computed: { 
    ...mapGetters({
      search: "getTrainingGroupSearch",
      page: "getTrainingGroupPage",
      total: "getTrainingGroupTotal",
      dataTraining: "getDataTraining",
    }),
    getBusinessType(){
      return (t) =>{
        switch (t){
            case '1':
            case 1:
                return this.$t("message.stock_business");
            case '2':
            case 2:
                return this.$t("message.derivative_business");
            case '4':
            case 4:
                return this.$t("message.found");
            default:
                return t;
        }
      }
    }

  },
  methods: {
    showLoader() {
      return this.$loading.show({
        container: this.$refs.formContainer,
        color: "#01B201",
        canCancel: true,
        onCancel: this.onCancelLoader
      });
    },
    async loadData(){
      console.log("it is loading from network");
      let loader = this.showLoader();
      let queryParams = {page: this.page};
      if(this.search.title){
          queryParams.title = this.search.title;
      }
      if(this.search.type){
          queryParams.type = this.search.type;
      }
      if(this.search.apply_for){
          queryParams.apply_for = this.search.apply_for;
      }
      const respone = await axios.get("training-group", {
        params: queryParams,
        headers: {
          Authorization: "Bearer " + this.$store.getters.getAuthToken
        }
      });
      if (respone.status == 200) {
        const d ={
          search: {...this.search},
          page: 1,
          total: respone.data.meta.total,
          dataTraining: [...respone.data.data]
        };
        this.$store.commit('changeTrainingGroup',d);
      }
      loader.hide();
    },
    async deleteData(item){
      this.$swal
        .fire({
          title: "តើអ្នកចង់លុបទិន្នន័យនេះមែនទេ?",
          showCancelButton: true,
          confirmButtonText: `យល់ព្រម`,
          cancelButtonText: `បោះបង់`
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            let loader = this.showLoader();
            if(item.id){
              const respone = await axios.delete("training-group/"+item.id,{
                headers: {
                  Authorization: "Bearer " + this.$store.getters.getAuthToken
                }
              });
              if(respone.status==200){
                const d = this.dataTraining.filter(v=>v.id != item.id);
                this.$store.commit('changeDataTraining',d);
              }
            }
            loader.hide();
          }
        });
    }
  },
  created() {
    if(this.dataTraining.length<=0){
      this.loadData();
    }
  },
  mounted() {}, components: {}
};
</script>
<style scoped>

div.content {
  margin-left: 200px;
  padding: 25px;
  height: auto;
  margin-top: 0;
}

@media screen and (max-width: 700px) {
  .sidebar {
    width: 100%;
    height: auto;
    position: relative;
  }
  .sidebar a {
    float: left;
  }
  div.content {
    margin-left: 0;
  }
}

.footer {
  margin-left: 200px;
}
</style>
